import { render, staticRenderFns } from "./EditPriceList.vue?vue&type=template&id=6756d31a"
import script from "./EditPriceList.vue?vue&type=script&lang=js"
export * from "./EditPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports